import React from "react";
import { Box, Button, Typography } from "@mui/material";

const ConflictActions = ({ onBack, onProceed, disableProceed, hasUnresolvedConflicts, isMobile }) => (
  <Box
    display="flex"
    flexDirection={isMobile ? "column" : "row"}
    justifyContent="flex-end"
    alignItems={isMobile ? "stretch" : "center"}
    gap={isMobile ? 1.5 : 2}
    mt={3}
  >
    {hasUnresolvedConflicts && (
      <Typography variant="h6" sx={{ color: "#d32f2f", fontWeight: 600, fontSize: "1.1rem" }}>
        ⚠ Some conflicts need resolution
      </Typography>
    )}
    <Button variant="outlined" onClick={onBack} fullWidth={isMobile}>
      Back to Collection
    </Button>
    <Button variant="contained" color="primary" disabled={disableProceed} onClick={onProceed} fullWidth={isMobile}>
      Proceed to Push Database
    </Button>
  </Box>
);

export default ConflictActions;
